/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConsultationContentDto } from '../../models/consultation-content-dto';

export interface ConsultationContentClientControllerFindByIdV1$Params {
  id: string;
}

export function consultationContentClientControllerFindByIdV1(http: HttpClient, rootUrl: string, params: ConsultationContentClientControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ConsultationContentDto>> {
  const rb = new RequestBuilder(rootUrl, consultationContentClientControllerFindByIdV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ConsultationContentDto>;
    })
  );
}

consultationContentClientControllerFindByIdV1.PATH = '/api/v1/consultation-contents/client/{id}';
